import {SERVICE_TYPES, LOGO_TYPES} from './helpers';

import eduroamLogo from 'url:../img/logo/eduroam-logo.png';
import edugainLogo from 'url:../img/logo/edugain-logo.png';
import edumeetLogo from 'url:../img/logo/edumeet-logo.png';
import eduvpnLogo from 'url:../img/logo/eduvpn-logo.png';
import pointtopointLogo from 'url:../img/logo/point-to-point-logo.png';
import sectigoLogo from 'url:../img/logo/sectigo-logo.png';
import perfsonarLogo from 'url:../img/logo/perfsonar-logo.png';
import geantfirewallLogo from 'url:../img/logo/geant-firewall-logo.png';
import cloudrashLogo from 'url:../img/logo/cloud-rash-logo.png';
import connectrashLogo from 'url:../img/logo/connect-rash-logo.png';
import intranetrashLogo from 'url:../img/logo/intranet-rash-logo.png';
import hostingrashLogo from 'url:../img/logo/hosting-rash-logo.png';
import virtualserverrashLogo from 'url:../img/logo/virtual-server-rash-logo.png';
import implementationEduroamIcon from 'url:../img/implementation_eduroam_icon.png';
import networkIcon from 'url:../img/network_icon.png';
import trafficIcon from 'url:../img/traffic_icon.png';
import filesenderLogo from 'url:../img/logo/filesender-logo.png';
import ni4osLogo from 'url:../img/logo/ni4os_albania_os.png';

import implementatOnOfEduroamInAlbaniaManual from 'url:../doc/implementat_on_of_eduroam_in_albania.pdf';
import lidhjetNeRrjetManual from 'url:../doc/lidhjet_ne_rrjet.pdf';

import universitiesJSON from '../json/universities.json';
import facultiesJSON from '../json/faculties.json';

export const state = {
    service: {
        id: 0,
        name: '',
        description: '',
        urlWebsite: '',
        urlLogin: '',
        logo: '',
        pdf: '',
        needLogin: true,
        type: '',
        university: {},
        universities: [],
        faculty: {},
        faculties: []
    },
    services: [
        {
            id: 1,
            name: 'eduroam',
            description: `
            Është një shërbim i sigurt për qasjen në roaming i zhvilluar për komunitetin ndërkombëtar të kërkimit dhe arsimit. Eduroam i lejon studentët, studiuesit/stafin akademik të kënë qasje në lidhjen e internetit në të gjitha institucionet brenda dhe jashtë vendit ku është implemetuar eduroam duke përdorur të njëjtat kredenciale. Eduroam është i implementuar në më shumë se 100 vende.
            `,
            urlWebsite: 'https://eduroam.org/',
            urlLogin: 'https://idp.rash.al/',
            logo: eduroamLogo,
            logoType: LOGO_TYPES.small,
            needLogin: true,
            type: SERVICE_TYPES.service
        },
        {
            id: 2,
            name: 'eduGAIN',
            description: `
            EduGAIN është një sistem që ndërlidh federatat e indetifikimit të kërkimit dhe arsimit në të gjithë botën. Mundëson shkëmbimin e besueshëm të informacionit ndërmjet ofruesve të shërbimeve dhe institucioneve kërkimore dhe arsimore. EduGAIN ofron akses në të gjitha shërbimet online që u duhen studentëve, studiuesëve si dhe stafit akademik duke minimizuar numrin e llogarive që përdoruesit dhe ofruesit e shërbimeve duhet të menaxhojnë.
            `,
            urlWebsite: 'https://edugain.org/',
            urlLogin: 'https://idp.rash.al/',
            logo: edugainLogo,
            logoType: LOGO_TYPES.small,
            needLogin: true,
            type: SERVICE_TYPES.service
        },
        {
            id: 3,
            name: 'eduMEET',
            description: `
            EduMEET është një platformë videokonference që është dizenjuar dhe zhvilluar nga GEANT. EduMEET është shërbim që mund të përdoret nga studentët si dhe stafi akademik dhe mund të implementohet nga të gjitha institucionet të cilat duan të kënë sistemin e tyre të videokonferencave. EduMEET është një shërbim open-source dhe është një alternativë shumë e mirë krahasuar me shërbimet me pagesë.
            `,
            urlWebsite: 'https://edumeet.org/',
            urlLogin: 'https://edumeet.rash.al/',
            logo: edumeetLogo,
            logoType: LOGO_TYPES.small,
            needLogin: false,
            type: SERVICE_TYPES.service
        },
        {
            id: 4,
            name: 'File Sender',
            description: `
            Është një aplikacion web që lejon përdoruesit e autentifikuar të dërgojnë në mënyrë të sigurt dhe lehtësisht skedarë (file) me madhësi të ndryshme tek njerëz të tjerë pa pagesë.
            `,
            urlWebsite: 'https://www.geant.org/Services/Storage_and_clouds/Pages/FileSender.aspx',
            urlLogin: 'https://filesender.rash.al/',
            logo: filesenderLogo,
            logoType: LOGO_TYPES.small,
            needLogin: true,
            type: SERVICE_TYPES.service
        },
        {
            id: 5,
            name: 'eduVPN',
            description: `
            EduVPN ofron një rrjet virtual privat që lejon mundësinë për të vendosur një lidhje të mbrojtur në rrjetit në momentin që është duke u përdorur një rrjet publik. Bën të mundur enkriptimin e trafikut si dhe maskimin e identitetit. EduVPN mund të përdoret nga të gjithë studentet si dhe nga kërkuesit/stafi akademik.
            `,
            urlWebsite: 'https://www.geant.org/Services/Connectivity_and_network/Pages/VPN_Services.aspx',
            urlLogin: 'https://eduvpn.rash.al/',
            logo: eduvpnLogo,
            logoType: LOGO_TYPES.small,
            needLogin: true,
            type: SERVICE_TYPES.service
        },
        {
            id: 6,
            name: 'GÈANT Point-to-Point',
            description: `
            Ky shërbim u mundëson NREN-eve lidhje Ethernet pikë në pikë midis pikave fundore të GÉANT-it që njihen si European points-of-presence (PoPs), në bazë të kërkesës. Më pas, NREN-et  mundësojnë lidhje të mëtejshme brenda rrjetit të tyre rajonal, me destinacionet e kërkuara.
            `,
            urlWebsite: 'https://www.geant.org/Services/Connectivity_and_network/Pages/GEANT_Point-to-Point.aspx',
            urlLogin: '',
            logo: pointtopointLogo,
            logoType: LOGO_TYPES.large,
            needLogin: true,
            type: SERVICE_TYPES.service
        },
        {
            id: 7,
            name: 'TCS-GÈANT IP',
            description: `
            TCS Trusted Certificate Service – Cerstifikata sigurie per faqet web dhe çdo faqe shërbimi brenda universitetit me domain-et: rash.al dhe edu.al. TCS është shërbim i ofruar në bashkëpunim me Sectigo për të bërë rritjen e sigurisë në internet duke lehtësuar vendosjen e çertifikatave dixhitale.
            `,
            urlWebsite: 'https://www.geant.org/Services/Trust_identity_and_security/Pages/TCS.aspx',
            urlLogin: 'https://cert-manager.com/customer/rash',
            logo: sectigoLogo,
            logoType: LOGO_TYPES.small,
            needLogin: true,
            type: SERVICE_TYPES.service
        },
        {
            id: 8,
            name: 'perfSONAR',
            description: `
            PerfSONAR përdoret për monitorim e përformancës së rrjetit duke lejuar administratorët e rrjetit të analizojnë dhe diagnostikojnë sjelljet e tij. PerfSONAR lejon që të kryhen matje aktive për throughput-in, përqindjen e humbjes së paketave (packet loss), vonesat (delay) dhe shqetësimet (jitter) si dhe regjistrojnë ndryshimet e rrugës në rrjet. PerfSONAR është open-source dhe mund të përdoret nga të gjitha institucionet e arsimit për të monitoruar rrejtin e brendshëm.
            `,
            urlWebsite: 'https://www.perfsonar.net/',
            urlLogin: '',
            logo: perfsonarLogo,
            logoType: LOGO_TYPES.small,
            needLogin: true,
            type: SERVICE_TYPES.service
        },
        {
            id: 9,
            name: 'GÈANT firewall on demand',
            description: `
            Firewall on Demand (FoD) është një sistem i fuqishëm i cili lejon përdoruesit e autorizuar, përmes një faqe web (web page), të krijojnë dhe shpërndajnë filtra firewall bazuar në rrjedhën e trafikur. Ky sistem lejon institucionet të filtrojnë dhe bllokojnë trafikun e dëmshëm (malicious traffik), i cili synon të dëmtojë rrjetin e brendshëm të institucionit. FoD bazohet në standarte të specifikuara në RFC 5575.
            `,
            urlWebsite: 'https://www.geant.org/Networks/Network_Operations/Pages/Firewall-on-Demand.aspx',
            urlLogin: 'https://fod.geant.net/welcome?next=/dashboard/',
            logo: geantfirewallLogo,
            logoType: LOGO_TYPES.small,
            needLogin: true,
            type: SERVICE_TYPES.service
        },
        {
            id: 10,
            name: 'RASH Cloud',
            description: `
            RASH ofron shërbime Cloud Computing (IaaS) për universitetet publike si: Makina Virtuale (Kubernetes, GitLab, Wordpress etj.), Storage, Networking etj. Në përgjithësi, janë tre elemente që karakterizojnë Cloud Computing: <br> 1. Backend, (kryesisht hardware) e cila menaxhohet totalisht nga RASH. <br> 2. Një përdorues paguan vetëm për shërbimet e përdorura (memorje RAM, CPU, Storage, Bandwidth etj.) të cilat janë të menaxhueshme. <br> 3. Mundësitë që i ofrohen konsumatorit janë të konfigurojë fuqinë përpunuese, ruajtjen e të dhënave, network-un dhe burime të tjera, ku konsumatori është në gjendje të vendosë dhe të menaxhojë një program arbitrar, i cili mund të përfshijë sisteme operative dhe aplikacione.
            `,
            urlWebsite: 'https://www.ocre-project.eu/services/cloud-suppliers/country/albania',
            urlLogin: 'https://cloud.rash.al/',
            logo: cloudrashLogo,
            logoType: LOGO_TYPES.medium,
            needLogin: true,
            type: SERVICE_TYPES.cloud
        },
        {
            id: 11,
            name: 'RASH Connect',
            description: `
            Gbps internet i dedikuar për te gjitha universitetet Lidhje L1 e dedikuar për secilin universitet me kapacitet deri në 1Gbps. Konektivitet i dedikuar deri ne 2 Gbps për lidhje me universitete/qendra kerkimi jashtë vendit, Databaza dhe Bibloteka të dhenash kerkimi, infrastrukture HPC Kapacitet deri në 2 Gbps bandwidth për konektivitet në shërbime të ndryshme të ofruara nga GEANT dhe lundrim të sigurtë në internet.
            `,
            urlWebsite: '',
            urlLogin: '',
            logo: connectrashLogo,
            logoType: LOGO_TYPES.medium,
            needLogin: false,
            type: SERVICE_TYPES.cloud
        },
        {
            id: 12,
            name: 'Intranet',
            description: `
            Lidhje me fibër të errët layer L1. Lidhje të të gjitha godinave të IAL-së në një rrjet të kampusit universitar. Lidhje me siguri maksimale point-to-point pa pajisje të ndërmjetme. Transmetim i sigurt i të dhënave në fibër optike me DB e sistemit e Sekretarisë të studentit dhe të gjitha sistemet online që RASH ofron si U-Financa, UCRIS, U-Albania. 
            `,
            urlWebsite: '',
            urlLogin: '',
            logo: intranetrashLogo,
            logoType: LOGO_TYPES.medium,
            needLogin: false,
            type: SERVICE_TYPES.cloud
        },
        {
            id: 13,
            name: 'Hosting',
            description: `
            Share Hosting është një nga tipet e hostimit të faqeve web në të cilën një server fizik/virtual hoston shumë të tillë.
            `,
            urlWebsite: '',
            urlLogin: 'https://webhosting.rash.al:10000/',
            logo: hostingrashLogo,
            logoType: LOGO_TYPES.medium,
            needLogin: true,
            type: SERVICE_TYPES.cloud
        },
        {
            id: 14,
            name: 'Virtual Server',
            description: `
            Hostim serverash virtual brenda infrastrukture të DC në RASH Magazinimi në cloud është një model i ruajtjes së të dhënave kompjuterike, në të cilin të dhënat dixhitale ruhen në servera fizik. Magazinimi fizik përfshin servera të shumtë, dhe mjedisi fizik zakonisht zotërohet dhe menaxhohet nga një kompani pritëse, në këtë rast menaxhohen nga RASH.
            `,
            urlWebsite: '',
            urlLogin: 'https://share.rash.al/login',
            logo: virtualserverrashLogo,
            logoType: LOGO_TYPES.medium,
            needLogin: true,
            type: SERVICE_TYPES.cloud
        },
        {
            id: 15,
            name: 'Komuniteti Shqiptar NI4OS',
            description: `
            Nisma Kombëtare për Shkencën e Hapur në Evropë - NI4OS Europe, synon të jetë një kontribues thelbësor në portofolin e shërbimit Evropian Open Science Cloud (EOSC), e të angazhohet nën drejtimin e EOSC dhe të sigurojë gjithëpërfshirje në nivelin Evropian për të mundësuar Shkencën e Hapur globale. 
            `,
            urlWebsite: 'https://training.ni4os.eu/course/view.php?id=54',
            urlLogin: 'https://ni4os.rash.al/sq/',
            logo: ni4osLogo,
            logoType: LOGO_TYPES.small,
            needLogin: false,
            type: SERVICE_TYPES.cloud
        },
        {
            id: 16,
            name: 'Lidhjet në rrjet',
            description: `
            `,
            urlWebsite: '',
            pdf: lidhjetNeRrjetManual,
            logo: networkIcon,
            logoType: LOGO_TYPES.large,
            needLogin: false,
            type: SERVICE_TYPES.manual
        },
        {
            id: 17,
            name: 'Implementimi i eduroam',
            description: `
            `,
            urlWebsite: '',
            pdf: implementatOnOfEduroamInAlbaniaManual,
            logo: implementationEduroamIcon,
            logoType: LOGO_TYPES.large,
            needLogin: false,
            type: SERVICE_TYPES.manual
        },
        {
            id: 18,
            name: 'Trafiku',
            description: `
            `,
            urlWebsite: 'https://public-brian.geant.org/d/goej8iQMz/rash?orgId=5',
            logo: trafficIcon,
            logoType: LOGO_TYPES.large,
            needLogin: false,
            type: SERVICE_TYPES.manual
        },
    ],
};

export const loadUniversities = function () {
    //  Load all universities
    state.service.universities = universitiesJSON.data;
};

export const loadUniversity = function (universityId) {
    if (!universityId) return;
    state.service.university = universitiesJSON.data.find(uni => uni.id === universityId);
};

export const loadFaculties = function (universityId = 0) {
    // If universityId is default load all faculty
    if (!universityId) state.service.faculties = facultiesJSON.data;

    // If universityId is NOT default load all faculty of the specified university
    if (universityId) state.service.faculties = facultiesJSON.data.filter(fac => fac.university === universityId);
};

export const loadFaculty = function (facultyId) {
    if (!facultyId) return;
    state.service.faculty = facultiesJSON.data.find(fac => fac.id === facultyId);
};
